var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('video',{directives:[{name:"video",rawName:"v-video",value:(_vm.videoUrl),expression:"videoUrl"}],attrs:{"controls":"","autoplay":"","playsinline":"","webkit-playsinline":"","type":"video/mp4","src":_vm.videoUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }